import usePagination from '@/hooks/pagination';
import { useEffect, useState } from 'react';
import { createCompany, deleteCompany, updateCompany, type Company } from '@/api/company.service';
import { getCompaniesByClient } from '@/api/client.service'
import { CrudPage } from '@/components/crud/CrudPage';
import { ModuleForm } from './ModuleForm';
import { useParams } from "react-router";
import { getClient, type Client } from '@/api/client.service';
import { Box } from '@mui/material';
import { ConfirmModal } from '@/components/ConfirmModal';
import { getUser, getUserCompanies, type User } from '@/api/user.service';

export const ModulePage = () => {
  const { total, setTotal, page, setPage, rowsPerPage, setRowsPerPage } = usePagination();
  const [companies, setCompanies] = useState<Company[]>([]);
  const [companyToDelete, setCompanyToDelete] = useState<Company>();
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState<User>();
  const { userId } = useParams<{ userId: string }>();
  const [openModal, setOpenModal] = useState(false);

  const loadCompanies = async () => {
    setIsLoading(true);
    try {
      if (!userId) return;

      // TODO: Make this return Count
      const data = await getUserCompanies(userId);
      setTotal(200);
      setCompanies(data);
    } catch (error) {
      console.error("Failed to fetch companies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadUser = async () => {
    setIsLoading(true);
    try {
      const data = await getUser(userId!);
      setUser(data);
    } catch (error) {
      console.error("Failed to fetch User", error);
    } finally {
      setIsLoading(false);
    }
  }

  const handleCreate = async (data: Company) => {
    // try {
    //   data.user_id = userId!;
    //   await createCompany(data);
    //   await loadCompanies();
    // } catch (error) {
    //   console.error("Error creating company:", error);
    // }
  };

  const handleUpdate = async (id: string, data: Partial<Company>) => {
    // try {
    //   await updateCompany(id, data);
    //   await loadCompanies();
    // } catch (error) {
    //   console.error("Error updating company:", error);
    // }
  };

  const handleDelete = async (id: string) => {
    // try {
    //   await deleteCompany(id);
    //   setCompanies(companies.filter((u) => u.id !== id));
    //   setOpenModal(false);
    // } catch (error) {
    //   console.error("Error deleting company:", error);
    // } finally {
    //   setOpenModal(false);
    // }
  };

  const handleOpenModal = async (id: string) => {
    // const company = companies.find((c) => c.id === id);
    // setCompanyToDelete(company);
    setOpenModal(true);
  };

  useEffect(() => {
    loadCompanies();
  }, [page, rowsPerPage]);

  useEffect(() => {
    loadUser()
  }, []);

  if (isLoading) return <div>Carregando empresas...</div>;

  return (
    <Box>

      <CrudPage
        title={`Módulos de ${user?.name}`}
        subtitle="Gerencie os módulos do usuário pela empresa"
        data={companies}
        getId={(u: Company) => u.id}
        columns={[
          { key: "cnpj", label: "CNPJ" },
          { key: "name", label: "Nome" },
          { key: "social_reason", label: "Razão Social" },
          { key: "erp_code", label: "Código ERP" },
        ]}
        total={total}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={setPage}
        onRowsPerPageChange={setRowsPerPage}
        Form={ModuleForm}
      />
    </Box>
  );
};